/**
 * Navigation Controller
 * Handles navbar state, mobile menu, and smooth scrolling
 */

class Navigation {
  constructor() {
    this.navbar = document.getElementById('navbar');
    this.navToggle = document.getElementById('nav-toggle');
    this.mobileMenu = document.getElementById('mobile-menu');
    this.navLinks = document.querySelectorAll('.nav-link, .mobile-link');
    
    this.init();
  }
  
  init() {
    this.setupScrollListener();
    this.setupMobileMenu();
  }
  
  setupScrollListener() {
    let lastScroll = 0;
    let ticking = false;
    
    window.addEventListener('scroll', () => {
      lastScroll = window.scrollY;
      
      if (!ticking) {
        window.requestAnimationFrame(() => {
          // Add scrolled class when past 50px
          if (lastScroll > 50) {
            this.navbar.classList.add('scrolled');
          } else {
            this.navbar.classList.remove('scrolled');
          }
          ticking = false;
        });
        
        ticking = true;
      }
    });
  }
  
  setupMobileMenu() {
    this.navToggle.addEventListener('click', () => {
      this.navToggle.classList.toggle('active');
      this.mobileMenu.classList.toggle('active');
      document.body.style.overflow = this.mobileMenu.classList.contains('active') 
        ? 'hidden' 
        : '';
    });
    
    // Close menu on link click
    const mobileLinks = document.querySelectorAll('.mobile-link');
    mobileLinks.forEach((link) => {
      link.addEventListener('click', () => {
        this.navToggle.classList.remove('active');
        this.mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      });
    });
  }
  

}

export default Navigation;
